import React from "react";
import FullScorecardTable from "./FullScorecardTable";
import NineHoleScorecardTable from "./NineHoleScorecardTable";

const ScorecardTable = (props) => {
  const { numHoles } = props;
  if (numHoles === 18) {
    return <FullScorecardTable {...props} />;
  } else if (numHoles === 9) {
    return <NineHoleScorecardTable {...props} />;
  } else {
    return null;
  }
};

export default ScorecardTable;